export default {
  profiles: 'Profiles',
  'profiles.domain.name': 'Name',
  'profiles.domain.roles': 'Roles',

  'profiles.create': 'Create New Profile',
  'profiles.create.notification.success': 'Success',
  'profiles.create.notification.successDescription': 'Profile created.',

  'profiles.update': 'Update Profile',
  'profiles.update.notification.success': 'Success',
  'profiles.update.notification.successDescription': 'Profile updated.',

  'profiles.remove': 'Remove Profile',
  'profiles.remove.alert': 'Do you really want to remove the profile:',
  'profiles.remove.notification.success': 'Success',
  'profiles.remove.notification.successDescription': 'Profile removed.',
};
